// redux/leadThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import axiosInstance from "../../utils/axios";
// To upload the excel file..
export const addExcelDataAction = createAsyncThunk(
  "lead/addExcelData",
  async ({ excelData, onSuccess, onError }, thunkAPI) => {
    try {
      for (const [key, value] of excelData.entries()) {
        console.log(key, value);
      }
      const response = await axiosInstance.post(
        "/Leads/Add-Excel-Data",
        excelData,
        { suppressToast: true }
      );
      if (response.status === 200) {
        onSuccess();
        return response.data;
      } else {
        const message = response.data?.details || "Failed to add excel data";
        onError(message);
        return thunkAPI.rejectWithValue(message);
      }
    } catch (error) {
      const message = error.response?.data?.details || error.message;
      onError(message);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// TO get and display the leads in table..
export const fetchLeadsAction = createAsyncThunk(
  "lead/fetchLeads",
  async ({ campaignId, onSuccess, onError }, thunkAPI) => {
    try {
      console.log(campaignId);
      const response = await axiosInstance.post("/Leads/Get-Leads", {
        campaignId: campaignId,
        // ✅ Correct query parameters
      });

      if (response.status === 200) {
        onSuccess?.();

        const { details } = response.data || {};

        // Handle informational message when there are no leads
        if (typeof details === "string") {
          const message = details;
          if (message.toLowerCase().includes("no leads found")) {
            return {
              leads: [],
              total_records: 0,
              total_pages: 0,
              current_page: 1,
            };
          }
          // If some other string, just return empty safely
          return {
            leads: [],
            total_records: 0,
            total_pages: 0,
            current_page: 1,
          };
        }

        const { leads, total_pages, total_records, current_page } = details || {};

        return {
          leads: leads || [],
          total_records: total_records || 0,
          total_pages: total_pages || 0,
          current_page: current_page || 1,
        };
      }

      throw new Error(response.data?.details || "Error fetching leads");
    } catch (error) {
      console.error("API request error:", error);

      const errorMessage =
        error.response?.data?.details || error.message || "An error occurred";

      onError?.(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

// Search leads by keyword
export const searchLeadsAction = createAsyncThunk(
  "lead/searchLeads",
  async ({ campaignId, name, onSuccess, onError }, thunkAPI) => {
    try {
      console.log("Searching leads:", { campaignId, name });
      const response = await axiosInstance.post("/Leads/search-leads", {
        campaignId: campaignId,
        name: name,
      });

      if (response.status === 200) {
        onSuccess?.();

        const { details } = response.data || {};
        const { leads, total_pages, total_records, current_page } =
          details || {};

        return {
          leads: leads || [],
          total_records: total_records || 0,
          total_pages: total_pages || 0,
          current_page: current_page || 1,
          isSearchResult: true, // Flag to indicate this is a search result
        };
      }

      throw new Error(response.data?.details || "Error searching leads");
    } catch (error) {
      console.error("Search API request error:", error);

      const errorMessage =
        error.response?.data?.details || error.message || "An error occurred";

      onError?.(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

// FETCH THE ALL COMPAINS..
export const fetchCampaignsAction = createAsyncThunk(
  "lead/fetchCampaigns",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get("/Leads/Get-Campaigns");
      if (response.status === 200) {
        // Transform the response to match the format expected by react-select
        // console.log('fetch compaig',response.data.details)
        let respo = response.data.details.map((campaign) => ({
          label: campaign.name,
          value: campaign.campaignId,
          status: campaign.status,
          worker_id: campaign.worker_id,
        }));

        return respo;
      } else {
        toast.error("Failed to fetch campaigns");
        return thunkAPI.rejectWithValue(response.data.details);
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.details || error.message
      );
    }
  }
);

// FETCH THE delete COMPAINS..
export const deleteCampaignsAction = createAsyncThunk(
  "lead/deleteCampaigns",
  async ({ identifier }, thunkAPI) => {
    // console.log(identifier)
    // return;
    try {
      const response = await axiosInstance.delete(
        "/Leads/delete_campaign/" + identifier
      );
      if (response.status === 200) {
        console.log(response);
        // Transform the response to match the format expected by react-select
        return {
          success: true,
          message: response.data.details,
          status: 200,
        };
      } else {
        toast.error("Failed to delete campaigns");
        return thunkAPI.rejectWithValue(response.data.details);
      }
    } catch (error) {
      toast.error(error.response?.data?.details || error.message);
      // console.log(thunkAPI.rejectWithValue(error));
      // return thunkAPI.rejectWithValue(error.response?.data?.details || error.message);
      return {
        success: false,
        message: error.response?.data?.details || error.message,
        status: 200,
      };
    }
  }
);

export const startCampaignAction = createAsyncThunk(
  "lead/startCampaign",
  async ({ campaignId }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        `/Leads/start-campaign`,
        { campaignId } // Send as object in request body
      );

      // Handle specific success response
      if (response.status === 200) {
        const { campaign } = response.data;
        toast.success(response.data.details);
        return {
          success: true,
          message: response.data.details,
          campaign: {
            id: campaign.id,
            name: campaign.name,
            status: campaign.status,
            agentEmail: campaign.agent_email,
            workerName: campaign.worker_name,
            teamLeadId: campaign.team_lead_id,
            agentId: campaign.agent_id,
            workerId: campaign.worker_id,
          },
          status: 200,
        };
      }

      // This block likely won't be reached due to axios throwing errors for non-200 responses,
      // but included for completeness
      toast.error(response.data.details || "Failed to start campaign");
      return thunkAPI.rejectWithValue(response.data.details);
    } catch (error) {
      // Handle specific error status codes
      const errorMessage = error.response?.data?.details || error.message;
      const status = error.response?.status || 500;

      switch (status) {
        case 400:
          // Handle validation errors or already active campaign
          {
            const data = error.response?.data || {};
            const msg = data.message || errorMessage || "Failed to start campaign";
            toast.error(msg, { autoClose: 7000, closeOnClick: true });
          }
          break;
        case 403:
          // Handle authorization errors
          toast.error("You are not authorized to start this campaign");
          break;
        case 404:
          // Handle campaign not found
          toast.error("Campaign not found");
          break;
        case 500:
        default:
          // Handle server errors
          toast.error(`Error starting campaign: ${errorMessage}`);
          break;
      }

      return {
        success: false,
        message: errorMessage,
        status: status,
      };
    }
  }
);

export const stopCampaignAction = createAsyncThunk(
  "lead/stopCampaign",
  async ({ campaignId }, thunkAPI) => {
    try {
      const response = await axiosInstance.patch(
        `/Leads/inactive_campaign/${campaignId}`
      );

      if (response.status === 200) {
        toast.success(response.data?.details || "Campaign stopped successfully");
        return response.data;
      }

      return thunkAPI.rejectWithValue(response.data?.details);
    } catch (error) {
      const message = error.response?.data?.details || error.message || "Something went wrong";
      toast.error(message);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Mark messages as read
export const markMessageReadAction = createAsyncThunk(
  "lead/markMessageRead",
  async ({ conversation_id, onSuccess, onError }, thunkAPI) => {
    try {
      console.log("Marking messages as read:", { conversation_id });
      const response = await axiosInstance.post("/Leads/Mark-Message-Read", {
        conversation_id: conversation_id,
        read: true,
      });

      if (response.status === 200) {
        onSuccess?.();
        return {
          conversation_id,
          success: true,
        };
      }

      throw new Error(response.data?.details || "Error marking messages as read");
    } catch (error) {
      console.error("Mark read API request error:", error);

      const errorMessage =
        error.response?.data?.details || error.message || "An error occurred";

      onError?.(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);
